"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = exports.isStringWithContent = exports.isString = exports.isTruthy = exports.isNotNull = exports.isNotUndefinedEntry = exports.isNotUndefined = void 0;
const isNotUndefined = (item) => {
    return item !== undefined;
};
exports.isNotUndefined = isNotUndefined;
const isNotUndefinedEntry = (entry) => {
    return !!entry && !!entry[0] && entry[1] !== undefined;
};
exports.isNotUndefinedEntry = isNotUndefinedEntry;
const isNotNull = (item) => {
    return item !== null;
};
exports.isNotNull = isNotNull;
const isTruthy = (item) => {
    return !!item;
};
exports.isTruthy = isTruthy;
const isString = (item) => {
    return typeof item === "string";
};
exports.isString = isString;
const isStringWithContent = (item) => {
    return (0, exports.isString)(item) && Boolean(item.trim());
};
exports.isStringWithContent = isStringWithContent;
const isObject = (item) => {
    return typeof item === "object" && item !== null;
};
exports.isObject = isObject;
//# sourceMappingURL=ArrayFilter.utils.js.map